import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  DEFAULT_CURRENCY_CODE,
  inject,
  Pipe,
  type PipeTransform,
} from '@angular/core';
import type { AttributeType } from '@bizzdesign/shared/models';

@Pipe({
  name: 'dynamicType',
  standalone: true,
})
export class DynamicTypePipe implements PipeTransform {
  currencyPipe = inject(CurrencyPipe);
  datePipe = inject(DatePipe);
  currencyCode = inject(DEFAULT_CURRENCY_CODE);

  transform(
    value: string,
    valueType: AttributeType,
    currency?: string,
    displayValue?: string,
  ): string {
    switch (valueType) {
      // make first letter uppercase
      case 'boolean':
        return value.charAt(0).toUpperCase() + value.slice(1);
      // format date to specific format, example: 10 June 2024
      case 'date':
        return this.datePipe.transform(value, 'd MMMM y') ?? '';
      // add currency code before amount
      case 'money':
        return `${currency ?? 'EUR'} ${this.currencyPipe.transform(value, '', '')}`;
      // return display label or id as fallback
      case 'enum':
      case 'reference':
        return displayValue ?? value;
      // return passed value
      case 'integer':
      case 'real':
      case 'string':
      case 'text':
        return value;

      default:
        return value;
    }
  }
}
